import { Link } from "react-router-dom";
import { memeCategories } from "@/mocks/memes";
import { siteInfo } from "@/mocks/site";

const helperLinks = [
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
  { label: "热梗榜", path: "/rank" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-sm font-bold text-primary-950">
                131
              </span>
              <span className="font-heading text-xl text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
              {siteInfo.slogan}。梗图、表情包、神评论与网友二创，每天整理一轮，聊天接梗不再卡壳。
            </p>
            <p className="mt-4 text-sm text-secondary-300">联系邮箱：{siteInfo.email}</p>
          </div>

          <div>
            <h2 className="font-heading text-base text-background-50">内容分类</h2>
            <ul className="mt-4 space-y-3 text-sm">
              {memeCategories.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/category/${item.slug}`}
                    className="text-background-200 transition-colors hover:text-secondary-300"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-base text-background-50">站点导航</h2>
            <ul className="mt-4 space-y-3 text-sm">
              {helperLinks.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-background-200 transition-colors hover:text-secondary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/category/all" className="text-background-200 transition-colors hover:text-secondary-300">
                  全部内容
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-base text-background-50">关于这个站点</h2>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              我们不做夸张的标题，只把好笑的、好用的、值得存下来的梗整理清楚。所有内容均来自网友分享与团队整理，如涉及版权问题请通过邮箱联系我们。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {siteInfo.name} · 内容仅供日常娱乐与交流使用
          </p>
          <p>本站为内容分享站点，图片版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}